import { SignatureComponent } from "@syncfusion/ej2-react-inputs";
import { useEffect, useRef, useState } from "react";
import { SignatureFieldProps } from "./SignatureField";

/**Hooks for Text Field*/
export const useSignatureField = (props: SignatureFieldProps) => {
  const [localDisabled, setLocalDisabled] = useState<boolean | undefined>(
    props.disabled
  );
  const [undoDisabled, setUndoDisabled] = useState<boolean | undefined>(true);
  const [clearDisabled, setClearDisabled] = useState<boolean | undefined>(
    false
  );
  const signatureComponent = useRef<SignatureComponent>(null);

  useEffect(() => {
    signatureComponent.current?.load(props.value || "");
  }, []);

  useEffect(() => {
    setLocalDisabled(props.disabled);
    setUndoDisabled(!signatureComponent.current?.canUndo());
    setClearDisabled(signatureComponent.current?.isEmpty());
  }, [props.disabled]);

  const getValue = (): string | null => {
    if (!signatureComponent.current) {
      return null;
    }

    return signatureComponent?.current?.isEmpty()
      ? null
      : signatureComponent.current.getSignature();
  };

  const submitValue = () => {
    if (signatureComponent.current) {
      props.onSubmit && props.onSubmit(getValue());
    }
  };

  return {
    signatureComponent,
    localDisabled,
    setLocalDisabled,
    undoDisabled,
    setUndoDisabled,
    clearDisabled,
    setClearDisabled,
    submitValue,
    getValue,
  };
};
